<template>
  <div class="detail-infos-wrap">
    <MultipleFilter :options="filterOptions"
                    @chacked="mutipleChacked"
                    @closeTag="handlecloseTag"
                    ref="MultipleFilter"></MultipleFilter>
    <SimpleFilter :keywords="keywords"
                  @search="handleSearch"
                  @issueTime="handleIssue"
                  @viewCount="handleView"
                  @handleDefault="handleDefault"></SimpleFilter>
    <div class="body-content-wrap">
      <div class="left">
        <div class="spin-wrap"
             v-if="loading">
          <a-spin :spinning="loading" />
        </div>
        <Empty v-if="isEmpty"
               class="empty-wrap"></Empty>
        <div class="card-wrap"
             v-if="!isEmpty && !loading">
          <GoodsCard v-for="item in tableList"
                     :key="item.id"
                     :instance="item"></GoodsCard>
        </div>
        <Pagination :total="total"
                    @pageChange="handleChange"></Pagination>
      </div>
      <div class="right">
        <SideCard @detailClick="detailClick"></SideCard>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import SimpleFilter from '@/components/common/SimpleFilter'
import GoodsCard from './components/goodsCard.vue'
import SideCard from './components/sideCard.vue'
import MultipleFilter from '@/components/MultipleFilter'
import Empty from '@/components/common/Empty/index'
import { filterOptions } from './config'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { mapGetters, mapMutations } from 'vuex'
import { getFrontList } from '@/api/technicalR'
const industryList = require('@/utils/industryList')
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      keywords: '', // 检索关键词
      filterOptions, // 多选过滤
      params: {
        pageNum: 1,
        pageSize: 10,
        // industrialType: 1
      },
      total: 0,
      body: {},
      loading: false,
      isEmpty: false,
      tableList: [],
      tag: '',
      searchVal: '',
      datas: '',
    }
  },
  components: {
    MultipleFilter,
    SimpleFilter,
    Pagination,
    GoodsCard,
    SideCard,
    Empty,
  },
  watch: {
    headSearchValueDemand: {
      handler() {
        this.initParams()
        if (
          Object.keys(this.$route.params).length === 0 ||
          this.$route.params.selectVal === undefined
        ) {
          this.initDefaultValue()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('headerSearch', ['headSearchValueDemand']),
  },
  mounted() {
    // 回显产业分类
    if (
      Object.keys(this.$route.params).length > 0 &&
      this.$route.params.selectVal !== undefined
    ) {
      let selectVal = JSON.parse(this.$route.params.selectVal)
      if (selectVal) {
        let obj = {
          fatherTag: '产业分类',
          childTagItem: selectVal,
          checked: true,
          instance: {
            isMore: false,
            hasMore: false,
            moreTitle: '展开',
            name: '产业分类',
            prop: 'industrialType',
            icon: '/static/cpfl.png',
            tagList: industryList.industryList,
            spliceIdx: -1,
          },
        }
        setTimeout(() => {
          this.$refs.MultipleFilter.checkTagHandler(obj)
        }, 1000)
      }
    }
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    // 初始化关键词、请求体
    initParams() {
      this.keywords = this.headSearchValueDemand
      this.body = {
        name: this.headSearchValueDemand,
      }
    },
    // 初始化方法
    async initDefaultValue() {
      try {
        this.loading = true
        let params = {
          name: this.body.patentName,
          demandsType: this.body.demandsType,
          searchValue: this.body.searchValue,
          industrialType: this.body.industrialType,
          companyType: this.body.companyType,
          tag: this.tag,
        }
        params.params = this.body.params
        this.params.demandsType = this.body.demandsType
        let { data } = await getFrontList(this.params, this.body)
        this.loading = false

        this.tableList = data.rows
        this.total = data.total
        let list = [
          { name: '技术难题', value: '1', key: 'demandsType1' },
          { name: '产品需求', value: '2', key: 'demandsType2' },
          { name: '服务需求', value: '3', key: 'demandsType3' },
          { name: '其他需求', value: '4', key: 'demandsType4' },
          { name: '不限', value: '', key: 'demandsType' },
        ]
        let industList = industryList.industryList
        let techList = [
          { label: '人类生活必需', value: '0' },
          { label: '作业；运输', value: '1' },
          { label: '化学；冶金', value: '2' },
          { label: '纺织；造纸', value: '3' },
          { label: '固定建筑物', value: '4' },
          { label: '机械工程；照明；加热；武器；爆破', value: '5' },
          { label: '物理', value: '6' },
          { label: '电学', value: '7' },
        ]
        this.tableList.forEach((item) => {
          list.forEach((ele) => {
            if (item.demandsType === ele.value) {
              item.demandsTypeStr = ele.name
            }
          })
          industList.forEach((ele) => {
            if (item.industrialType === ele.value) {
              item.industrialTypeStr = ele.label
            }
          })
          techList.forEach((ele) => {
            if (item.technicalType === ele.value) {
              item.technicalTypeStr = ele.label
            }
          })
        })
        this.isEmpty = this.tableList.length === 0
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    mutipleChacked(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name,
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })
      this.datas = datas
      this.body = { name: this.searchVal, ...datas }
      this.initDefaultValue()
    },
    // 多选tag处理
    handlecloseTag(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name,
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })
      this.datas = datas
      this.body = { name: this.searchVal, ...datas }
      this.initDefaultValue()
    },
    handleSearch(e) {
      this.searchVal = e
      //合并多选按钮的选择
      const params = { name: e, ...this.datas }
      this.body = params
      // this.updateTabValue({ key: 'result', value: e })
      this.initDefaultValue()
    },
    // 切换页面
    handleChange(e) {
      this.params.pageNum = e
      this.initDefaultValue()
    },
    // 简单筛选恢复默认
    handleDefault() {
      delete this.body.params
      this.initDefaultValue()
    },
    // 发布时间筛选
    handleIssue(e) {
      this.body = { ...this.body, params: { sort: e, sortType: '0' } }
      this.initDefaultValue()
    },
    // 浏览量筛选
    handleView(e) {
      this.body = { ...this.body, params: { sort: e, sortType: '1' } }
      this.initDefaultValue()
    },
    detailClick(val) {
      console.log(val)
      this.tag = val
      this.initDefaultValue()
    },
  },
  destroyed() {
    // 重置vuex中的tab值
    this.updateTabValue({ key: 'result', value: '' })
  },
}
</script>
